/**
 * Permission utilities for ART Garage
 */

export const ALL_PERMISSIONS = [
  "can_view_customers",
  "can_create_customers",
  "can_edit_customers",
  "can_delete_customers",
  "can_create_jobs",
  "can_edit_jobs",
  "can_delete_jobs",
  "can_archive_jobs",
  "can_view_archived_jobs",
  "can_edit_archived_jobs",
  "can_progress_job_status",
  "can_enter_prices",
  "can_edit_prices",
  "can_view_payments",
  "can_create_payments",
  "can_enter_payments",
  "can_edit_payments",
  "can_view_financial_summary",
  "can_upload_photos",
  "can_change_job_status",
  "can_view_logs",
  "can_manage_staff",
  "can_assign_staff",
  "can_view_vehicle_history",
  "can_approve_critical_changes",
  "can_view_kvkk_status",
  "can_manage_control_appointments",
  "can_mark_control_attended",
];

export const PERMISSION_LABELS = {
  can_view_customers: "Müşteri Görüntüleme",
  can_create_customers: "Müşteri Oluşturma",
  can_edit_customers: "Müşteri Düzenleme",
  can_delete_customers: "Müşteri Silme",
  can_create_jobs: "İş Oluşturma",
  can_edit_jobs: "İş Düzenleme",
  can_delete_jobs: "İş Silme",
  can_archive_jobs: "İş Arşivleme",
  can_view_archived_jobs: "Arşiv Görüntüleme",
  can_edit_archived_jobs: "Arşiv Düzenleme",
  can_progress_job_status: "Durum İlerletme",
  can_enter_prices: "Fiyat Girişi",
  can_edit_prices: "Fiyat Düzenleme",
  can_view_payments: "Ödeme Görüntüleme",
  can_create_payments: "Ödeme Oluşturma",
  can_enter_payments: "Ödeme Girişi",
  can_edit_payments: "Ödeme Düzenleme",
  can_view_financial_summary: "Finansal Özet",
  can_upload_photos: "Fotoğraf Yükleme",
  can_change_job_status: "Durum Değiştirme",
  can_view_logs: "Log Görüntüleme",
  can_manage_staff: "Personel Yönetimi",
  can_assign_staff: "Personel Atama",
  can_view_vehicle_history: "Araç Geçmişi",
  can_approve_critical_changes: "Kritik Onay",
  can_view_kvkk_status: "KVKK Durumu",
  can_manage_control_appointments: "Kontrol Yönetimi",
  can_mark_control_attended: "Kontrol Katılımı",
};

export const ROLE_LABELS = {
  admin: "Admin",
  manager: "Yönetici",
  sales: "Satış",
  technician: "Uygulamacı",
};

export function hasPermission(user, perm) {
  if (!user) return false;
  if (user.role === "admin" || user.isAdmin) return true;
  return (user.permissions || []).includes(perm);
}

export function getUserPermissions(user) {
  if (!user) return [];
  if (user.role === "admin" || user.isAdmin) return ALL_PERMISSIONS;
  return user.permissions || [];
}
